<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">A Woman of the Iron People</h1>
<p class="author" style="margin-top:60px;">Eleanor Arnason</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section1.vue?2dbfe33d